module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-469.7b116a9.woff2";